/**
 * TLM Kit
 *
 * Copyright © 2007-present SOHO Systems and Networks. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Layout from '../../components/Layout';
import Page from '../../components/Page';
import content from './content.md';

function action() {
  return {
    chunks: ['privacy'],
    title: content.title,
    component: (
      <Layout>
        <Page {...content} />
      </Layout>
    ),
  };
}

export default action;
